import React, { useState, useEffect } from 'react';
import { Award } from 'lucide-react';
import { getOrganization } from '../../services/firestoreService';

const Founding100Badge = ({ orgId }) => {
  const [orgData, setOrgData] = useState(null);

  useEffect(() => {
    if (!orgId) return;
    const load = async () => {
      const org = await getOrganization(orgId);
      if (org && org.isFounding100) setOrgData(org);
    };
    load();
  }, [orgId]);

  if (!orgData) return null;

  return (
    <div
      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg mb-4"
      style={{
        background: 'linear-gradient(135deg, #071D39 0%, #1a3a5c 100%)',
        border: '1px solid #805AD5',
        boxShadow: '0 0 12px rgba(128, 90, 213, 0.3)',
      }}
    >
      <Award className="w-5 h-5" style={{ color: '#D4AF37' }} />
      <span className="text-sm font-bold" style={{ color: '#D4AF37' }}>
        {Number.isInteger(orgData.foundingNumber) && orgData.foundingNumber >= 1 && orgData.foundingNumber <= 100
          ? `Founding Member #${orgData.foundingNumber} of 100`
          : 'Founding 100 Member'}
      </span>
    </div>
  );
};

export default Founding100Badge;